import React, { useState, useEffect } from "react";
import VisibilityApi from "../state/Visibility-api";
import { lclContainerBulkUpdate } from "../StaticData";
import { configStore, dataListStore } from "../state/CommonState";
import Api from "../state/Api";
import { loader } from "../util/loader";
import BookingsApi from "../state/bookings-api";
import { myactionsstore } from "./store-myactions";
import Newapi from "../state/new-api";

const ContainerUpdatePopup = ({ visible, setVisible, fl_vessel_name, setFlVesselName }) => {
  const [containerNo, setContainerNo] = useState(fl_vessel_name || "");
  const [error, setError] = useState("");
  const [checking, setChecking] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [container, setContainer] = useState({});
  const [searchText, setSearchText] = useState('');
  const [containerList, setContainerList] = useState([]);
  const [showContainerList, setShowContainerList] = useState(false);
  const [exceptionList, setExceptionList] = useState([]);
  const [rmkeys, setrmkeys] = useState([]);
  const [bulkFields, setBulkFields] = useState(lclContainerBulkUpdate);

useEffect(() => {
    let rm  = []
    let data = configStore.modalvisibledata;
    
    for (let i = 0; i < 4; i++) {
      if(data[`ts${i+1}_port`]!=undefined && data[`ts${i+1}_port`]!=null && data[`ts${i+1}_port`].trim().length > 0){
        rm.push(`ts${i+1}_port`)
        rm.push(`ts${i+1}_arrival_estimate`)
        rm.push(`ts${i+1}_arrival`)
        rm.push(`ts${i+1}_departure_estimate`)
        rm.push(`ts${i+1}_departure`)
        rm.push(`ts${i+1}_vessel_name`)
        rm.push(`ts${i+1}_vessel_number`)
      }
    }
  let tsFields = [];
  if (rm?.length > 0) {
    const getLabel = (field) => {
      const [, ts, key] = field.match(/^ts(\d+)_(.+)$/);
      const leg = Number(ts) + 1; // ts1 => 2nd Leg, ts2 => 3rd Leg

      const labels = {
        port: `Transhipment ${ts} Port (if any)`,
        arrival_estimate: `ETA Transhipment ${ts}`,
        arrival: `ATA Transhipment ${ts}`,
        departure_estimate: `ETD Transhipment ${ts}`,
        departure: `ATD Transhipment ${ts}`,
        vessel_name: `${leg}${leg === 2 ? "nd" : leg === 3 ? "rd" : "th"} Leg Vessel Name`,
        vessel_number: `${leg}${leg === 2 ? "nd" : leg === 3 ? "rd" : "th"} Leg Voyage #`,
      };

      return labels[key] || field;
    };

    tsFields = rm.map((key) => ({
      key,
      label: getLabel(key),
      disabled:
        key.includes("port")
          ? true
          : false,
      type:
        key.includes("arrival") || key.includes("departure")
          ? "date"
          : "text",
    }));
  }
  setBulkFields([
    ...lclContainerBulkUpdate,
    ...tsFields,
  ]);
  if(rm?.length > 0){
    let transhipment = {};
    rm.map((ele) => { transhipment[ele] = data[ele] })
    
    const fields = [
      "port",
      "arrival_estimate",
      "arrival",
      "departure_estimate",
      "departure",
      "vessel_name",
      "vessel_number",
    ];
    setContainer((prev) => {
      const updated = { ...prev };
      for (let i = 1; i <= 4; i++) {
        if (updated[`ts${i}_port`]) {
          [
            "port",
            "arrival_estimate",
            "arrival",
            "departure_estimate",
            "departure",
            "vessel_name",
            "vessel_number",
          ].forEach((field) => {
            delete updated[`ts${i}_${field}`];
          });
        }
      }
      return {
        ...updated,
        ...transhipment,
        unset: configStore.modalvisibledata?.unset
      };
    });
  }else{
    setContainer((prev) => {
      const updated = { ...prev };
      for (let i = 1; i <= 4; i++) {
        if (updated[`ts${i}_port`]) {
          [
            "port",
            "arrival_estimate",
            "arrival",
            "departure_estimate",
            "departure",
            "vessel_name",
            "vessel_number",
          ].forEach((field) => {
            delete updated[`ts${i}_${field}`];
            
          });
        }
      }
      return {
        ...updated,
        unset: configStore.modalvisibledata?.unset
      };
    });
  }
  
}, [configStore.modalvisibledata]);

  useEffect(() => {
    Api.getFCLCarrierList();
  }, []);

  useEffect(() => {
    setContainerNo(fl_vessel_name || "");
  }, [fl_vessel_name]);

  useEffect(() => {
    const regex = /^[A-Z]{4}\d{7}$/;

    if (regex.test(containerNo)) {
      const checkContainer = async () => {
        setChecking(true);
        setError("");

        try {
          loader.show();
          const res = await VisibilityApi.containerUpdate({
            container_number: containerNo,
            update: false,
          });
          if(res?.exists){
            const data = await Newapi.getAllDsr4Displaybyid1(res?.exists?._id);
            configStore.modalvisibledata = data[0];
            setExceptionList(data[0]?.exceptionData || [])
          }
          if (res?.exists) {
            setContainer(res.exists || {});
            setDisabled(false);
          } else {
            setError("This container number doesn't exist.");
          }
        } catch (err) {
          console.error(err);
          setError("Error checking container number.");
        } finally {
          setChecking(false);
          loader.hide();
        }
      };

      checkContainer();
    } else {
      setContainer({});
      setExceptionList([])
      setDisabled(true);
    }
  }, [containerNo]);

  const handleClose = () => {
    configStore.modalvisibledata = {};
    delete configStore.modalvisibledata.unset
    setBulkFields(lclContainerBulkUpdate)
    setContainer({});
    setDisabled(true);
    setContainerNo("");
    setShowContainerList(false);
    setSearchText('');
    setVisible(false);
  };

const handleSave = async () => {
  try {
    loader.show();

    // Convert all date fields to dd-mm-yyyy before sending
    const formattedContainer = { ...container };
    bulkFields
      .filter(f => f.type === "date")
      .forEach(f => {
        const val = formattedContainer[f.key];
        if (val && /^\d{4}-\d{2}-\d{2}$/.test(val)) {
          const [y, m, d] = val.split("-");
          formattedContainer[f.key] = `${d}-${m}-${y}`;
        }
      });
    const res = await VisibilityApi.containerUpdate({
      ...formattedContainer,
      ...(configStore.modalvisibledata?.exceptionData?.length > 0 && { exceptionData: configStore.modalvisibledata?.exceptionData }),
      container_number: containerNo,
      update: true,
    });

    if (res?.updated) {
      configStore.setModalMessage(`${res.modifiedCount} booking(s) updated.`);
      setBulkFields(lclContainerBulkUpdate)
      setContainer({});
      setDisabled(true);
      setContainerNo("");
      setShowContainerList(false);
      setSearchText('');
      setVisible(false);
      configStore.modalvisibledata = {};
      myactionsstore.recheck = myactionsstore.recheck === 0 ? 1 : 0;
    } else {
      setError("This container number doesn't exist.");
    }
  } catch (err) {
    console.error(err);
    setError("Error checking container number.");
  } finally {
    loader.hide();
  }
};


  const fetchContainerList = async () => {
    try {
      loader.show();
      if (!showContainerList) {
        const res = await new Promise((resolve, reject) => {
          BookingsApi.getContainerList((data) => resolve(data));
        });
        setContainerList(res || []);
        setShowContainerList(true);
      } else {
        setShowContainerList(false);
      }
    } catch (err) {
      console.error(err);
      configStore.setModalMessage("Failed to fetch container list.");
    } finally {
      loader.hide();
    }
  };

  if (!visible) return null;

  return (
    <div className="modal is-active">
      <div className="modal-background" onClick={handleClose}></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">LCL Container Update</p>
          <button className="delete" aria-label="close" onClick={handleClose}></button>
        </header>
        <section className="modal-card-body">
          <div className="field">
            <label className="label is-small">Container No</label>
            <div className="is-flex">
              <input
                className="input is-small"
                type="text"
                placeholder="ABCD1234567"
                value={containerNo}
                maxLength={11}
                onChange={(e) => {
                  let val = e.target.value.toUpperCase();

                  if (val.length <= 4) {
                    val = val.replace(/[^A-Z]/g, "");
                  } else if (val.length > 4) {
                    const firstPart = val.slice(0, 4).replace(/[^A-Z]/g, "");
                    const secondPart = val.slice(4).replace(/[^0-9]/g, "");
                    val = firstPart + secondPart;
                  }

                  setContainerNo(val);
                  setError("");
                }}
              />
              <button
                className="button is-small is-info ml-2"
                type="button"
                onClick={fetchContainerList}
              >
                Browse Container
              </button>
            </div>
            {checking && <p className="help is-info">Checking container...</p>}
            {error && <p className="help is-danger">{error}</p>}
          </div>

          {showContainerList && (
            <div className="mt-2 border rounded-md p-2 max-h-60 overflow-y-auto w-full">
              {/* Search Input */}
              <input
                type="text"
                className="input is-small mb-2"
                placeholder="Search container / POL / POD"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />

              {/* Filtered List */}
              {containerList.filter(c => {
                const search = searchText.toLowerCase();
                return (
                  c.pol_container_number.toLowerCase().includes(search) ||
                  (c.pol || '').toLowerCase().includes(search) ||
                  (c.pod || '').toLowerCase().includes(search)
                );
              }).length > 0 ? (
                containerList
                  .filter(c => {
                    const search = searchText.toLowerCase();
                    return (
                      c.pol_container_number.toLowerCase().includes(search) ||
                      (c.pol || '').toLowerCase().includes(search) ||
                      (c.pod || '').toLowerCase().includes(search)
                    );
                  })
                  .map((c, idx) => (
                    <div
                      key={idx}
                      className="p-2 hover:bg-gray-200 cursor-pointer border-b"
                      onClick={() => {
                        setContainerNo(c.pol_container_number);
                        setShowContainerList(false);
                      }}
                    >
                      <div className="font-semibold text-sm">POL: {c.pol || 'NA'} / POD: {c.pod || 'NA'}</div>
                      <div className="text-gray-700 text-xs mt-1">
                        Container: {c.pol_container_number}
                      </div>
                    </div>
                  ))
              ) : (
                <p className="p-2 text-gray-500">No containers found.</p>
              )}
            </div>
          )}

          <div className="columns is-multiline is-variable is-2">

            <div className="column is-half">
              <div className="field">
                <label className="label is-small">Carrier</label>
                <div className="control">
                  <div className="select is-small is-fullwidth">
                    <select
                      value={container.carrier || ""}
                      disabled={disabled}
                      onChange={(e) =>
                        setContainer({ ...container, carrier: e.target.value })
                      }
                    >
                      <option value="">Select Carrier</option>
                      {dataListStore["FCLCarrierList"]?.map((carrier, idx) => (
                        <option
                          key={idx}
                          value={`${carrier["Display Name"]} (${carrier["SCAC code"]})`}
                        >
                          {`${carrier["Display Name"]} (${carrier["SCAC code"]})`}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {bulkFields.map((field, idx) => (
              <div className="column is-half" key={idx}>
                <div className="field">
                  <label className="label is-small">{field.label}</label>
                  <div className="control">
                    <input
                      disabled={disabled || field.disabled}
                      className="input is-small"
                      type={field.type === "date" ? "date" : field.type}
                      value={
                        field.type === "date" && container[field.key]
                          ? (() => {
                            const val = container[field.key];
                            if (/^\d{2}-\d{2}-\d{4}$/.test(val)) {
                              const [d, m, y] = val.split("-");
                              return `${y}-${m}-${d}`; 
                            }
                            return val;
                          })()
                          : container[field.key] || ""
                      }
                      onChange={(e) =>
                        setContainer({
                          ...container,
                          [field.key]: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            ))}

          </div>
          {exceptionList && exceptionList.length > 0 ? (
              <button
                className="button is-link"
                onClick={async () => {
                  myactionsstore.exceptionModalVisible = true;
                }}
              >
                👁 View Exception
              </button>
            ) : (
              <button
                disabled={disabled}
                className="button is-link is-outlined"
                onClick={async () => {
                  myactionsstore.exceptionModalVisible = true;
                }}
              >
                + Add Exception
              </button>
          )}
          {bulkFields && bulkFields.length > lclContainerBulkUpdate.length ? (
              <button
                className="button ml-5 is-link"
                onClick={async () => {
                  myactionsstore.tsModalVisible = true;
                }}
              >
                👁 View Transhipment
              </button>
            ) : (
              <button
                disabled={disabled}
                className="button ml-5 is-link is-outlined"
                onClick={async () => {
                  myactionsstore.tsModalVisible = true;
                }}
              >
                + Add Transhipment
              </button>
          )}
        </section>

        <footer className="modal-card-foot is-flex">
          <button className="button is-warning" onClick={handleClose}>
            Cancel
          </button>
          <div className="ml-auto">
            <button className="button is-link" onClick={handleSave} disabled={disabled}>
              Update
            </button>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default ContainerUpdatePopup;
